<template>
  <div>
    <page-section :title="$t('Integrations_Overview_Information')">
      <form-section>
        {{ $t(integration.description) }}
      </form-section>
    </page-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import PageSection from '@/common/components/page/PageSection'

export default {
  name: 'DefaultOverview',

  components: {
    FormSection,
    PageSection
  },

  props: {
    integration: {
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/DefaultOverview.vue